import { ActionTree, MutationTree, GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import cloneDeep from 'lodash/cloneDeep';
import { saveAs } from 'file-saver';
import { fetchEnumsFromSchema } from '@/core/tools/forms/fetch_enums_from_schema';
import { prepareFormObjectForSave } from '@/core/tools/forms/prepare_form_object_for_save';

interface ShiftAtomFactState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    documentId: any;
    clientId: any;

    // productList: any[];
    // productVariantList: any[];
    prefereds: any;
    relatedFactsList: any[];
    meta: any;

    targetForDelete: any[];
    // inWorkStatus: any;
    // formationStatus: any;
    // products: any[];
    remains: any[];
}

const state: ShiftAtomFactState = {
    loading: false,
    loaded: false,
    fatalError: false,

    documentId: null,
    clientId: null,
    meta: {},

    // productList: [],
    // productVariantList: [],
    prefereds: [],
    relatedFactsList: [],

    targetForDelete: [],
    // products: [],
    remains: []
};

const initState: any = cloneDeep(state);

const GET_SHIFT_FACT_ATOM = 'GET_SHIFT_FACT_ATOM';
const GET_SCMEMA_SHIFT_FACT_ATOM = 'GET_SCMEMA_SHIFT_FACT_ATOM';
const GET_SCMEMA_SHIFT_ATOM = 'GET_SCMEMA_SHIFT_ATOM';
const SHIFT_PLAN = 'SHIFT_PLAN';
const SHIFT_PLAN_CNT = 'SHIFT_PLAN_CNT';
const SHIFT_FACT = 'SHIFT_FACT';
const SHIFT_FACT_STORAGES = 'SHIFT_FACT_STORAGES';
const SHIFT_JOURNAL= 'SHIFT_JOURNAL';


export const actions: ActionTree<ShiftAtomFactState, RootState> = {
    reset({ commit }) {
        commit('RESET_STATE')
    },

    loadData({ commit, getters, dispatch, state }, { documentId, clientId, remains }) {
        const vm = (this as any)._vm;

        state.documentId = documentId;
        state.clientId = clientId;
        state.remains = remains;

        return new Promise((resolve, reject) => {
          commit('START_LOADING');
          vm.$db([
            vm.$q(GET_SHIFT_FACT_ATOM)
              .raw('documents.list')
              .action({
                columns: {
                  id: 'sfa.id',
                  plan_id: 'sa.id',
                  coock_plan_id: 'sa.coock_plan_id',
                  number: 'sa.number',
                  product_name: {$concat: ['p.name', {$: " "}, 'pc.name']},
                  technology: 'sa.technology',
                  container_name: 'vc.name',
                  remains_container_name: 'vcr.name',
                  mark_type: 'sa.mark_type',
                  fact_container_name: 'vcf.name',
                  provider_name: 'vp.name',
                  plan_weight: 'sa.plan_weight',
                  common_weight: 'sa.common_weight',
                  plan_quantity: 'sa.quantity',
                  remains_plan_weight: {$sub: ['sa.common_weight', {$mul: ['sa.quantity', 'vc.weight']}]},
                  plan_container_weight: 'vcr.weight',
                  remains_plan_quantity: 'vcr.weight',
                  quantity: 'sfa.quantity',
                  fact_weight: 'sfa.fact_weight',
                  coock_number: {$concat: ['sacp.number', {$: " ("}, 'pp.name', {$: ")"}]},
                  total_weight: {$sum: 'sjai.value'},  
                  clots_weight: 'sja.clots_weight',
                  label_text: 'sfa.label_text',
                  comment: 'sfa.comment',
                },
                from: 's:shift_atom',
                from_as: 'sa',
                joins: [
                  {
                    join: 's:shift_fact_atom',
                    type: 'left',
                    as:   'sfa',
                    on: {
                      $eq: ['sfa.plan_id', 'sa.id']
                    }
                  },
                  {
                    join: 's:products',
                    type: 'left',
                    as:   'p',
                    on: {
                      $eq: ['sa.product_id', 'p.id']
                    }
                  },
                  {
                    join: 's:product_containers',
                    type: 'left',
                    as:   'pc',
                    on: {
                      $eq: ['sa.product_container_id', 'pc.id']
                    }
                  },
                  {
                    join: 's:voc_containers',
                    type: 'left',
                    as:   'vc',
                    on: {
                      $eq: ['sa.container_id', 'vc.id']
                    }
                  },
                  {
                    join: 's:voc_containers',
                    type: 'left',
                    as:   'vcr',
                    on: {
                      $eq: ['sa.remains_container_id', 'vcr.id']
                    }
                  },
                  {
                    join: 's:voc_containers',
                    type: 'left',
                    as:   'vcf',
                    on: {
                      $eq: ['sfa.container_id', 'vcf.id']
                    }
                  },
                  {
                    join: 's:voc_providers',
                    type: 'left',
                    as:   'vp',
                    on: {
                      $eq: ['sfa.provider_id', 'vp.id']
                    }
                  },
                  {
                    join: 's:shift_atom_coock_plan',
                    type: 'left',
                    as:   'sacp',
                    on: {
                      $eq: ['sa.coock_plan_id', 'sacp.id']
                    }
                  },
                  {
                    join: 's:produced_products',
                    type: 'left',
                    as:   'pp',
                    on: {
                      $eq: ['sacp.product_id', 'pp.id']
                    }
                  },
                  {
                    join: 's:shift_journal_atom',
                    type: 'left',
                    as:   'sja',
                    on: {
                      $eq: ['sja.plan_id', 'sa.coock_plan_id']
                    }
                  },
                  {
                    join: 's:shift_journal_atom_ingredients',
                    type: 'left',
                    as:   'sjai',
                    on: {
                      $eq: ['sjai.journal_id', 'sja.id']
                    }
                  },
                ],
                order: [
                  {$asc: ['sa.number']}
                ],
                page: 1,
                page_size: 1000,
                where: {
                  $and: [
                    {$eq: [`sa.shift_id`, {$: documentId}]},
                  ]
                },
                groups: [
                  'sfa.id',
                  'sa.id',
                  'sa.number',
                  'p.name',
                  'pc.name',
                  'sa.technology',
                  'vc.name',
                  'vcr.name',
                  'sa.mark_type',
                  'vcf.name',
                  'vp.name',
                  'sa.quantity',
                  'sa.common_weight',
                  'vc.weight',
                  'vcr.weight',
                  'sfa.quantity',
                  'vcf.weight',
                  'sfa.fact_weight',
                  'sacp.id',
                  'pp.id',
                  'sja.id',
                  'sa.coock_plan_id',
                ]
              }),
              vm.$q(GET_SCMEMA_SHIFT_FACT_ATOM)
              .raw('schemas.get')
              .action({
                  id: `s:shift_fact_atom`
              }),
              vm.$q(GET_SCMEMA_SHIFT_ATOM)
              .raw('schemas.get')
              .action({
                  id: `s:shift_atom`
              }),
          ]).then((result: ServerResult) => {
            const opRelResult = result.getOperation(GET_SHIFT_FACT_ATOM);
            if (!opRelResult.hasError()) {
              state.relatedFactsList = opRelResult.getContent().documents.map((item: any) => {
                item.marks_count = 0;
                item.marks_count += item.mark_no_incident !== null ? 1 : 0;
                item.marks_count += item.mark_water_state !== null ? 1 : 0;
                item.marks_count += item.mark_no_fat !== null ? 1 : 0;
                item.marks_count += item.mark_normal_acidity !== null ? 1 : 0;
                return item
              })
            }
            const opRelSchemaFact = result.getOperation(GET_SCMEMA_SHIFT_FACT_ATOM);
            const opRelSchemaPlan = result.getOperation(GET_SCMEMA_SHIFT_ATOM);
            if (!opRelSchemaFact.hasError()) {
              state.meta = fetchEnumsFromSchema({...opRelSchemaFact.getContent().schema, ...opRelSchemaPlan.getContent().schema} )
            }
            commit('LOADED_SUCCESS');

            resolve(null);
          });
        })
    },

    exportAsXLSX({rootState, state}, {documentId}) {
      const vm = (this as any)._vm;

      return new Promise((resolve, reject) => {
          vm.$db([
              vm.$q('EXPORT')
              .raw('documents.report')
              .action({
                template: `
<!DOCTYPE html>
<table font=Verdana font-size=10 orientation="portrait" area="A:K" scale="45">
<tr height=30>
  <td wrap border bold bgcolor=FF72BF44 width=30>Номер партии</td>
  <td wrap border bold bgcolor=FF72BF44 width=40>Наименование продукта (этикетка)</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Технология базы</td>
  <td wrap border bold bgcolor=FF72BF44 width=25>Маркировка</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Тара, эквивалент в кг</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Поставщик тары</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Плановое кол-во выпуска, шт</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Кол-во выпущенного продукта, шт</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Отклонение от плана розлива, шт</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Плановое кол-во выпуска, кг</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Фактическое кол-во выпуска, кг</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Кол-во заложенного сырья, кг</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Отклонения, кг</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Отклонения, %</td>
  <td wrap border bold bgcolor=FF72BF44 width=40>Комментарий</td>
</tr>
{{#facts.documents}}
  <tr>
    <td wrap border>{{coock_number}}</td>
    <td wrap border>{{product_name}}</td>
    <td wrap border>{{technology}}</td>
    <td wrap border>{{mark_type}}</td>
    <td wrap border>{{fact_container_name}}</td>
    <td wrap border>{{provider_name}}</td>
    <td wrap border type=number round align=center>{{plan_quantity}}</td>
    <td wrap border type=number round align=center>{{quantity}}</td>
    <td wrap border type=number round align=center>{{deviant_quantity}}</td>
    <td wrap border type=number round align=center>{{common_weight}}</td>
    <td wrap border type=number round align=center>{{fact_weight}}</td>
    <td wrap border type=number round align=center>{{total_weight}}</td>
    <td wrap border type=number round align=center>{{total_weight}}</td>
    <td wrap border>{{comment}}</td>
  </tr>
{{/facts.documents}}
</table>
                `,
                queries: {
                  facts: {
                    columns: {
                  id: 'sfa.id',
                  plan_id: 'sa.id',
                  coock_plan_id: 'sa.coock_plan_id',
                  number: 'sa.number',
                  product_name: {$concat: ['p.name', {$: " "}, 'pc.name']},
                  technology: 'sa.technology',
                  container_name: 'vc.name',
                  remains_container_name: 'vcr.name',
                  mark_type: 'sa.mark_type',
                  fact_container_name: 'vcf.name',
                  provider_name: 'vp.name',
                  plan_weight: 'sa.plan_weight',
                  common_weight: 'sa.common_weight',
                  plan_quantity: 'sa.quantity',
                  remains_plan_weight: {$sub: ['sa.common_weight', {$mul: ['sa.quantity', 'vc.weight']}]},
                  plan_container_weight: 'vcr.weight',
                  remains_plan_quantity: 'vcr.weight',
                  quantity: 'sfa.quantity',
                  deviant_quantity: {$sub: ['sa.quantity', 'sfa.quantity']},
                  fact_weight: 'sfa.fact_weight',
                  coock_number: {$concat: ['sacp.number', {$: " ("}, 'pp.name', {$: ")"}]},
                  total_weight: {$sum: 'sjai.value'},  
                  clots_weight: 'sja.clots_weight',
                  label_text: 'sfa.label_text',
                  comment: 'sfa.comment',
                },
                from: 's:shift_atom',
                from_as: 'sa',
                joins: [
                  {
                    join: 's:shift_fact_atom',
                    type: 'left',
                    as:   'sfa',
                    on: {
                      $eq: ['sfa.plan_id', 'sa.id']
                    }
                  },
                  {
                    join: 's:products',
                    type: 'left',
                    as:   'p',
                    on: {
                      $eq: ['sa.product_id', 'p.id']
                    }
                  },
                  {
                    join: 's:product_containers',
                    type: 'left',
                    as:   'pc',
                    on: {
                      $eq: ['sa.product_container_id', 'pc.id']
                    }
                  },
                  {
                    join: 's:voc_containers',
                    type: 'left',
                    as:   'vc',
                    on: {
                      $eq: ['sa.container_id', 'vc.id']
                    }
                  },
                  {
                    join: 's:voc_containers',
                    type: 'left',
                    as:   'vcr',
                    on: {
                      $eq: ['sa.remains_container_id', 'vcr.id']
                    }
                  },
                  {
                    join: 's:voc_containers',
                    type: 'left',
                    as:   'vcf',
                    on: {
                      $eq: ['sfa.container_id', 'vcf.id']
                    }
                  },
                  {
                    join: 's:voc_providers',
                    type: 'left',
                    as:   'vp',
                    on: {
                      $eq: ['sfa.provider_id', 'vp.id']
                    }
                  },
                  {
                    join: 's:shift_atom_coock_plan',
                    type: 'left',
                    as:   'sacp',
                    on: {
                      $eq: ['sa.coock_plan_id', 'sacp.id']
                    }
                  },
                  {
                    join: 's:produced_products',
                    type: 'left',
                    as:   'pp',
                    on: {
                      $eq: ['sacp.product_id', 'pp.id']
                    }
                  },
                  {
                    join: 's:shift_journal_atom',
                    type: 'left',
                    as:   'sja',
                    on: {
                      $eq: ['sja.plan_id', 'sa.coock_plan_id']
                    }
                  },
                  {
                    join: 's:shift_journal_atom_ingredients',
                    type: 'left',
                    as:   'sjai',
                    on: {
                      $eq: ['sjai.journal_id', 'sja.id']
                    }
                  },
                ],
                order: [
                  {$asc: ['sa.number']}
                ],
                where: {
                  $and: [
                    {$eq: [`sa.shift_id`, {$: documentId}]},
                  ]
                },
                groups: [
                  'sfa.id',
                  'sa.id',
                  'sa.number',
                  'p.name',
                  'pc.name',
                  'sa.technology',
                  'vc.name',
                  'vcr.name',
                  'sa.mark_type',
                  'vcf.name',
                  'vp.name',
                  'sa.quantity',
                  'sa.common_weight',
                  'vc.weight',
                  'vcr.weight',
                  'sfa.quantity',
                  'vcf.weight',
                  'sfa.fact_weight',
                  'sacp.id',
                  'pp.id',
                  'sja.id',
                  'sa.coock_plan_id',
                ]
                  },
                },
                format: 'xlsx'
              })
          ]).then(((result: ServerResult) => {
              const exportOpContent = result.getOperation('EXPORT').getContent();
              const fToken = exportOpContent.token;
              const aToken = (rootState as any).ubic.token
              const fileUrl = `${process.env.VUE_APP_UBIC_SERVER_ADDRESS}/api/v1/exports/${fToken}?authorization=${aToken}`;
              saveAs(fileUrl, 'export.xlsx')

              resolve();
          }));
      })
    },

};

export const mutations: MutationTree<ShiftAtomFactState> = {
  RESET_STATE: (state) => {
      for(const key in initState) {
          (state as any)[key] = initState[key]
      }
  },
  START_LOADING: (state) => {
      state.loaded = false;
      state.loading = true;
      state.fatalError = false;
  },
  LOADED_SUCCESS: (state) => {
      state.loaded = true;
      state.loading = false;
      state.fatalError = false;
  },
  LOADED_ERROR: (state) => {
      state.loaded = true;
      state.loading = false;
      state.fatalError = true;
  },
};

export const getters: GetterTree<ShiftAtomFactState, RootState> = {
  totals : (state: ShiftAtomFactState) => {
    return state.relatedFactsList.reduce((val: any, item: any) => {
        const keys = ['weight_brutto', 'weight_neto', 'deviant_weight', 'weight_palett', 'plan_weight']
        keys.map((key: string) => {
          if (!val[key]) {
            val[key] = 0
          }
          val[key] += item[key] ? parseFloat(item[key]) : 0
        })
        return val
      }, {})
    },
    rotateFacts: (state: ShiftAtomFactState) => {
      const rows =  state.relatedFactsList.reduce((prev: any, item: any) => {
        Object.keys(item).map((key: any) => {
          if (!prev[key]){
            prev[key] = [];
          }
          if (key == 'total_weight') {
            item.total_weight = (parseFloat(item.total_weight) + parseFloat(item.clots_weight) * ( parseFloat(item.clots_weight) < 1000 ? 1000 : 1)) / 1000
          }
          prev[key].push(item[key]);
        })
        prev.rows.push(item)
        return prev
      }, {rows: []})  
      const groups = rows.coock_plan_id ? rows.coock_plan_id.reduce((prev: any, item: any, idx: number) => {
        if (!prev[item]) {
          prev[item] = {count: 0, idx: []}
        }
        prev[item].count += 1
        prev[item].idx.push(idx)
        return prev
      }, {}) : {}

      rows.class_names = []

      rows.coock_number = rows.coock_number ? rows.coock_number.map((item: any, idx: number) => {
        const coock_plan_id = groups[rows.coock_plan_id[idx]]
        rows.class_names[idx] = Object.keys(groups).indexOf(rows.coock_plan_id[idx]) % 2 == 0 ? 'col-strip' : '';
        if (coock_plan_id.idx.indexOf(idx) == 0) {
          item = {
            value: item,
            count: coock_plan_id.count,
            class_name: rows.class_names[idx]
          }
        } else {
          item = null
        }
        return item
      }).filter((item: any) => {return item}) : null
      rows.total_weight = rows.total_weight ? rows.total_weight.map((item: any, idx: number) => {
        const coock_plan_id = groups[rows.coock_plan_id[idx]]
        rows.class_names[idx] = Object.keys(groups).indexOf(rows.coock_plan_id[idx]) % 2 == 0 ? 'col-strip' : '';
        if (coock_plan_id.idx.indexOf(idx) == 0) {
          item = {
            value: item,
            class_name: rows.class_names[idx],
            fact: rows.fact_weight.reduce((acc: number, item: any, idx: number) => {
              if (coock_plan_id.idx.indexOf(idx) > -1) {
                acc += parseFloat(item)
              }
              return acc
            }, 0),
            count: coock_plan_id.count
          }
        } else {
          item = null
        }
        return item
      }).filter((item: any) => {return item}) : null

      return rows
    }
};

export const STORE_KEY = '$_shift_atom_fact_list';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
